import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { TaskListPage } from '../../pages/tasks/TaskListPage';

export const Route = createFileRoute('/tasks/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TaskListPage />;
}
